export const VpBaseMethods = {
  vpSwitchScene: 'vpSwitchScene',
  vpSwitchNextScene: 'vpSwitchNextScene',
  vpInstall: 'vpInstall',
  vpGameEnd: 'vpGameEnd',
  vpSendAction: 'vpSendAction',
  vpPosition: 'vpPosition',
  vpScaleXY: 'vpScaleXY',
  vpRotate: 'vpRotate',
  vpWidth: 'vpWidth',
  vpHeight: 'vpHeight',
  vpShowHide: 'vpShowHide',
  vpAlpha: 'vpAlpha',
  vpColor: 'vpColor',
  vpWaitTime: 'vpWaitTime',
  vpClearTime: 'vpClearTime',
  enabledEvent: 'enabledEvent',
  enabledEventActive: 'enabledEventActive',
  enabledEventBan: 'enabledEventBan',
  // 背景音乐
  vpPlayBgm: 'vpPlayBgm',
  vpReplayBgm: 'vpReplayBgm',
  vpResumeBgm: 'vpResumeBgm',
  vpStopBgm: 'vpStopBgm',
  vpShakeScreen: 'vpShakeScreen',
  vpCompute: 'vpCompute',
  vpRetry: 'vpRetry',
}
